<template>
  <div id="profissionais-lotacoes">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Profissionais e Lotações"
            description=""
            url="/administracao"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-2791"
            pageIdentifier="profissionais-lotacoes"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="info-table">
            <div class="info-table-item"></div>
            <div class="info-table-item">
              <DownloadFiles
                :pdf-enabled="false"
                :callback-pdf="null"
                :data="displayedCadastrosXls"
                :fields="dataFields"
                name="profissionais-lotacoes"
              />
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <tabela-cadastros
            :cadastros="cadastros"
            :loading="loading"
          ></tabela-cadastros>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import TabelaCadastros from './TabelaCadastros.vue'
import SectionTitle from '@/components/SectionTitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { dataFields } from './utils.js'

export default {
  metaInfo: {
    title: 'Profissionais e Lotações',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    TabelaCadastros,
    SectionTitle,
    DownloadFiles,
  },
  data() {
    return {
      cadastros: [],
      loading: false,
      dataFields: { ...dataFields },
    }
  },
  computed: {
    displayedCadastrosXls() {
      return this.cadastros
        .map((item, index) => {
          let lotacoes = []

          if (item.lotacoes) {
            try {
              lotacoes =
                typeof item.lotacoes === 'string'
                  ? JSON.parse(item.lotacoes)
                  : item.lotacoes
            } catch (e) {
              lotacoes = []
            }
          }

          // Mantém apenas as lotações ativas
          lotacoes = lotacoes.filter(
            (lotacao) => Number(lotacao.st_ativo) === 1
          )

          return {
            ...item,
            id: index,
            lotacoes,
          }
        })
        .filter((item) => item.st_lotacao_ativa == 1)
    },
  },
  mounted() {
    this.buscarLotacoesDosProfissionais()
  },
  methods: {
    /**
     * Buscar as lotações dos profissionais
     */
    async buscarLotacoesDosProfissionais() {
      try {
        this.loading = true
        const response = await this.$api.get(
          '/app/profissionais-lotacoes/' + this.$store.state.cod_ibge + '/0'
        )
        if (response) {
          this.cadastros = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style></style>
